import React, {useState, useEffect} from 'react';
import { getRecords } from './helpers/apihandler';


function ViewRecords(){

    const [fastestRecords, setFastestRecords] = useState([]);
    const [slowestRecords, setSlowestRecords] = useState([]);
	const [higestPoints, setHighestPoints] = useState({});
	const [bestPPR, setBestPPR] = useState({});
	const [mostWins, setMostWins] = useState([]);

    

    useEffect(() =>{

        const loadRecords= async () => {

            let recRes =  await getRecords();
            console.log(recRes);
            setFastestRecords(recRes.fastest);
            setSlowestRecords(recRes.slowest);
            setHighestPoints(recRes.highestpoints);
            setMostWins(recRes.mostwins);
            setBestPPR(recRes.bestppr);
        }
        if (fastestRecords.length === 0){
            loadRecords();
        }
        
    })

    

    return(<><h5 style={{textDecoration:'underline'}}>Fastest Racers (all time)</h5><div style={{paddingTop:'10px', paddingBottom:'20px'}}>
				<header style={{textDecoration:'underline'}}>
						<div className="col">Date</div>
						<div className="col">Racer</div>
						<div className="col">Owner</div>
						<div className="col">Race Type</div>
						<div className="col">Strokes</div>
				</header>
			{fastestRecords.map(function(fastlist,i) {
				return <div key={i} className="row" style={{backgroundColor:(i % 2 === 0 ? 'rgba(0, 0, 0, 0.4)' : 'unset')}}><div className="col">Week of {fastlist.racedate}</div><div className="col"><a style={{color:'#69cdee'}} target="_blank" rel="noreferrer" href={'https://opensea.io/assets/matic/0x72106bbe2b447ecb9b52370ddc63cfa8e553b08c/' + fastlist.racer}>{fastlist.racer}</a></div><div className="col">{fastlist.teamname}</div><div className="col">{fastlist.racetype}</div><div className="col">{fastlist.steps}</div></div>;
			})}
		</div><h5 style={{textDecoration:'underline'}}>Slowest Racers (all time)</h5><div style={{paddingTop:'10px', paddingBottom:'20px'}}>
				<header style={{textDecoration:'underline'}}>
						<div className="col">Date</div>
						<div className="col">Racer</div>
						<div className="col">Owner</div>
						<div className="col">Race Type</div>
						<div className="col">Strokes</div>
				</header>
			{slowestRecords.map(function(fastlist,i) {
				return <div key={i} className="row" style={{backgroundColor:(i % 2 === 0 ? 'rgba(0, 0, 0, 0.4)' : 'unset')}}><div className="col">Week of {fastlist.racedate}</div><div className="col"><a style={{color:'#69cdee'}} target="_blank" rel="noreferrer" href={'https://opensea.io/assets/matic/0x72106bbe2b447ecb9b52370ddc63cfa8e553b08c/' + fastlist.racer}>{fastlist.racer}</a></div><div className="col">{fastlist.teamname}</div><div className="col">{fastlist.racetype}</div><div className="col">{fastlist.steps}</div></div>;
			})}
		</div><h5 style={{textDecoration:'underline'}}>Highest Points (all time)</h5><div style={{paddingTop:'10px', paddingBottom:'20px'}}>
				<header style={{textDecoration:'underline'}}>
						<div className="col">Date</div>
						<div className="col">Team</div>
						<div className="col">Points</div>
				</header><div className="row"  style={{backgroundColor:'rgba(0, 0, 0, 0.4)'}}><div className="col">Week of {higestPoints.racedate}</div><div className="col">{higestPoints.teamname}</div><div className="col">{higestPoints.points}</div></div>
				</div>
				<h5 style={{textDecoration:'underline'}}>Best Points Per Racer(all time, minimum 30 racers, regular weekly racing)</h5><div style={{paddingTop:'10px', paddingBottom:'20px', }}>
				<header style={{textDecoration:'underline'}}>
						<div className="col">Date</div>
						<div className="col">Team</div>
						<div className="col">Points</div>
						<div className="col"># of Racers</div>
						<div className="col">PPR</div>
				</header><div className="row" style={{backgroundColor:'rgba(0, 0, 0, 0.4)'}}><div className="col">Week of {bestPPR.racedate}</div><div className="col">{bestPPR.teamname}</div><div className="col">{bestPPR.points}</div><div className="col">{bestPPR.racercount}</div><div className="col">{bestPPR.ppr}</div></div>
				</div>
				<h5 style={{textDecoration:'underline'}}>Most 1st Place Finishes (all time, excluding playoffs)</h5><div style={{paddingTop:'10px', paddingBottom:'20px', }}>
				<header style={{textDecoration:'underline'}}>
						<div className="col">Racer</div>
						<div className="col">Owner</div>
						<div className="col">Wins</div>
				</header>
			{mostWins.map(function(winslist,i) {
				return <div key={i} className="row" style={{backgroundColor:(i % 2 === 0 ? 'rgba(0, 0, 0, 0.4)' : 'unset')}}><div className="col" ><a style={{color:'#69cdee'}}  target="_blank" rel="noreferrer" href={'https://opensea.io/assets/matic/0x72106bbe2b447ecb9b52370ddc63cfa8e553b08c/' + winslist.racer}>{winslist.racer}</a></div><div className="col">{winslist.teamname}</div><div className="col">{winslist.finishes}</div></div>;
			})}
		</div></>)
}


export {ViewRecords}